var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type && _vm.models)?_c('b-container',{attrs:{"fluid":""}},[_c('page-title',{attrs:{"icon":"fas fa-boxes"}},[_c('translate',[_vm._v("Shipments")])],1),_vm._v(" "),_c('api-list',{attrs:{"type":"shippings","model":_vm.models.shippings,"quick-filters":_vm.quickFiltersSetup.shippings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }